import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';

import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import vuetify from './plugins/vuetify';
import '@/styles/slick.css';
import '@/styles/slick-theme.css';
import '@/styles/style.css';
import '@/styles/custom-style.css';

import textFormatter from "@/utils/textFormatter";
import imageUtils from "@/utils/imageUtils";

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(i18n);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

app.config.globalProperties.$customTextFormatter = textFormatter;
app.config.globalProperties.$customImageUtil = imageUtils;

app.mount('#app');